import Veraportal from "./Veraportal";
import {IGruppe, IPortalseite, ISchueler_testsAPI, TFach} from "./Interfaces";
import Utilities from "./Utilities";
import Tooltip from './Tooltip';

export default class Benachrichtigungscenter extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        let benachrichtigungenDom = document.querySelector(`#benachrichtigungscenter div.benachrichtigungen`);

        //region Benachrichtigungsdefinition
        let boxHtml: string = ``;

        if (this.schulstatus.is_ok_schueler_ohne_geschlecht_warnung === 0) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Schüler ohne ausgewähltes Geschlecht</h2>
        <p>Allen Teilnehmenden muss ein Geschlecht zugewiesen werden. Prüfen Sie Ihre Eingaben in
        der Schüler-Verwaltung bzw. klicken Sie im Folgenden auf die Betroffenen, um direkt dorthin zu gelangen.
        Fälchlicherweise erstellte SuS können dort mit einem Klick auf <i>"Schüler:in deaktivieren"</i> in allen nachfolgenden Ansichten ausgeblendet werden.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_schueler_ohne_geschlecht_warnung.map((nr: number) => {
                return `<a href="/schuelerverwaltung.php" class="sprungmarke-schueler" data-nr="${nr}">${nr.toString().padStart(3, '0')}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (this.schulstatus.is_ok_schueler_ohne_stammklasse_warnung === 0) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Schüler ohne zugewiesene Stammklasse</h2>
        <p>Alle Teilnehmenden müssen einer Stammklasse zugewiesen werden. Durch die Gruppenzuordnung wird dann automatisch das Testheft zugewiesen.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_schueler_ohne_stammklasse_warnung.map((nr: number) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-schueler" data-nr="${nr}">${nr.toString().padStart(3, '0')}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (this.schulstatus.is_ok_stammklassen_ohne_schueler_warnung === 0) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Stammklassen ohne zugewiesene Schüler</h2>
        <p>Stammklassen Ihrer Schule enthalten weniger als eine/n Schüler:in. Deaktivieren Sie die entsprechenden Stammklassen in der Gruppenzuordnung.</p>
        <h3>Betroffene Stammklassen:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_stammklassen_ohne_schueler_warnung.map((bezeichnung: string) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-gruppe" data-bezeichnung="${bezeichnung}">${bezeichnung}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (this.schulstatus.is_ok_kurse_ohne_schueler_warnung === 0) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>${(this.sessionvariablen.schule.land !== 'ni') ? `Kurse` : `Lerngruppen`} ohne zugewiesene Schüler</h2>
        <p>${(this.sessionvariablen.schule.land !== 'ni') ? `Kurse` : `Lerngruppen`} Ihrer Schule enthalten weniger als eine/n Schüler:in. Deaktivieren Sie die entsprechenden Kurse in der Gruppenzuordnung.</p>
        <h3>Betroffene ${(this.sessionvariablen.schule.land !== 'ni') ? `Kurse` : `Lerngruppen`}:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_kurse_ohne_schueler_warnung.map((bezeichnung: string) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-gruppe" data-bezeichnung="${bezeichnung}">${bezeichnung}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (
            this.schulstatus.is_ok_schueler_ohne_mathematik_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_mathematik_testheft_warnung)
        ) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Schüler haben kein zugewiesenes Testheft im Fach Mathematik</h2>
        <p>Obwohl Mathematik verpflichtend in Ihrem Bundesland durchgeführt wird, haben einzelne Schüler kein ausgewähltes Testheft in diesem Fach.
        Die Auswahl des Testheftes ergibt sich aus der Gruppenzuordnung in Stammklasse bzw. Kurs. Prüfen Sie die Gruppenzuordnung der entsprechenden SuS
        und verifizieren Sie das in der zuständigen Gruppe ausgewählte Testheft.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_schueler_ohne_mathematik_testheft_warnung.map((nr: number) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-schueler" data-nr="${nr}">${nr.toString().padStart(3, '0')}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (
            this.schulstatus.is_ok_schueler_ohne_deutsch_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_deutsch_testheft_warnung)
        ) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Schüler haben kein zugewiesenes Testheft im Fach Deutsch</h2>
        <p>Obwohl Deutsch verpflichtend in Ihrem Bundesland durchgeführt wird, haben einzelne Schüler kein ausgewähltes Testheft in diesem Fach.
        Die Auswahl des Testheftes ergibt sich aus der Gruppenzuordnung in Stammklasse bzw. Kurs. Prüfen Sie die Gruppenzuordnung der entsprechenden SuS
        und verifizieren Sie das in der zuständigen Gruppe ausgewählte Testheft.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_schueler_ohne_deutsch_testheft_warnung.map((nr: number) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-schueler" data-nr="${nr}">${nr.toString().padStart(3, '0')}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (
            this.schulstatus.is_ok_schueler_ohne_englisch_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_englisch_testheft_warnung)
        ) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Schüler haben kein zugewiesenes Testheft im Fach Englisch</h2>
        <p>Obwohl Englisch verpflichtend in Ihrem Bundesland durchgeführt wird, haben einzelne Schüler kein ausgewähltes Testheft in diesem Fach.
        Die Auswahl des Testheftes ergibt sich aus der Gruppenzuordnung in Stammklasse bzw. Kurs. Prüfen Sie die Gruppenzuordnung der entsprechenden SuS
        und verifizieren Sie das in der zuständigen Gruppe ausgewählte Testheft.<br/> Sofern Schüler stattdessen ein Testheft in Französisch zugewiesen haben, entfallen sie in dieser Benachrichtigung.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_schueler_ohne_englisch_testheft_warnung.map((nr: number) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-schueler" data-nr="${nr}">${nr.toString().padStart(3, '0')}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (
            this.schulstatus.is_ok_schueler_ohne_franzoesisch_testheft_warnung === 0 &&
            JSON.stringify(this.schulstatus.list_schueler_ohne_stammklasse_warnung) !== JSON.stringify(this.schulstatus.list_schueler_ohne_franzoesisch_testheft_warnung)
        ) {
            boxHtml += `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Schüler haben kein zugewiesenes Testheft im Fach Französisch</h2>
        <p>Obwohl Französisch verpflichtend in Ihrem Bundesland durchgeführt wird, haben einzelne Schüler kein ausgewähltes Testheft in diesem Fach.
        Die Auswahl des Testheftes ergibt sich aus der Gruppenzuordnung in Stammklasse bzw. Kurs. Prüfen Sie die Gruppenzuordnung der entsprechenden SuS
        und verifizieren Sie das in der zuständigen Gruppe ausgewählte Testheft.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
        ${this.schulstatus.list_schueler_ohne_franzoesisch_testheft_warnung.map((nr: number) => {
                return `<a href="/gruppen-zuordnung.php" class="sprungmarke-schueler" data-nr="${nr}">${nr.toString().padStart(3, '0')}</a>`
            }).join('')}
        </div>
    </div>
</div>`;
        }

        if (this.schulstatus.is_ok_unvollstaendige_tests_mathematik_warnung === 0)
            boxHtml += this.ergebnisdatenWarnungenHtml('ma', this.schulstatus.list_unvollstaendige_tests_mathematik_warnung ?? []);

        if (this.schulstatus.is_ok_unvollstaendige_tests_deutsch_warnung === 0)
            boxHtml += this.ergebnisdatenWarnungenHtml('de', this.schulstatus.list_unvollstaendige_tests_deutsch_warnung ?? []);

        if (this.schulstatus.is_ok_unvollstaendige_tests_englisch_warnung === 0)
            boxHtml += this.ergebnisdatenWarnungenHtml('en', this.schulstatus.list_unvollstaendige_tests_englisch_warnung ?? []);

        if (this.schulstatus.is_ok_unvollstaendige_tests_franzoesisch_warnung === 0)
            boxHtml += this.ergebnisdatenWarnungenHtml('fr', this.schulstatus.list_unvollstaendige_tests_franzoesisch_warnung ?? []);
        //endregion

        // Hinweis anzeigen, wenn keine Benachrichtigungen angezeigt werden TODO:low Stringlänge ist doofe Prüfung
        if (boxHtml.length < 10) {
            boxHtml += `<span><i>Derzeit gibt es keine Benachrichtigungen zu Ihrer ${this.sessionvariablen.projekt.bezeichnung}-Jahrgangsstufe. Prüfen Sie über die Statusübersicht, ob alle Testgruppen Ihren Wünschen entsprechen.</i></span>`
        }

        benachrichtigungenDom.innerHTML = boxHtml;


        return true;
    }

    private ergebnisdatenWarnungenHtml(fach: TFach, testIds: readonly number[]): string {
        const tests = testIds
            .map((testId: number) => this.testliste.filter(t => t.schueler_test_id === testId)[0] ?? null)
            .filter((test: ISchueler_testsAPI | null): test is ISchueler_testsAPI => test !== null);

        const cbtTestsOhneErgebnisse = tests.filter(test => this.isCbtTest(fach, test) && test.ergebnisse.length === 0);
        const testsFuerErgebnisdateneingabe = tests.filter(test => !this.isCbtTest(fach, test) || test.ergebnisse.length > 0);

        return this.cbtAuswertungWarnungHtml(fach, cbtTestsOhneErgebnisse) + this.ergebnisdateneingabeWarnungHtml(fach, testsFuerErgebnisdateneingabe);
    }

    private cbtAuswertungWarnungHtml(fach: TFach, tests: readonly ISchueler_testsAPI[]): string {
        const fachLang = Utilities.printFachLang(fach);
        const cbtDomain = this.cbtDomain();
        const gruppen = this.eindeutigeCbtTestgruppen(fach, tests)
            .map((gruppe: IGruppe) => {
                const lehrkraftZugangscode = this.lehrkraftZugangscode(fach, gruppe);
                if (lehrkraftZugangscode === null || cbtDomain === null)
                    return ``;

                return `<a href="https://www.${cbtDomain}?tkn=${lehrkraftZugangscode}" class="sprungmarke-cbt" target="_blank" rel="noopener" aria-label="Auswertung der CBT-Testgruppe ${gruppe.bezeichnung} prüfen" data-tooltip="${Tooltip.html`
                    <p><strong>CBT-Testgruppe ${gruppe.bezeichnung}</strong></p>
                    <p>Öffnet die Auswertung dieser Testgruppe im CBT-Portal.</p>
                `}">${gruppe.bezeichnung}</a>`;
            })
            .filter(html => html !== '');

        if (gruppen.length === 0)
            return '';

        return `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>CBT-Auswertung im Fach ${fachLang} noch nicht übertragen</h2>
        <p>Für die folgenden CBT-Testgruppen liegen im Portal noch keine Ergebnisdaten vor. Prüfen Sie die Auswertung im CBT-Portal.</p>
        <h3>Betroffene Testgruppen:</h3>
        <div class="betroffene">
            ${gruppen.join('')}
        </div>
    </div>
</div>`;
    }

    private ergebnisdateneingabeWarnungHtml(fach: TFach, tests: readonly ISchueler_testsAPI[]): string {
        const fachLang = Utilities.printFachLang(fach);
        const schuelerLinks = tests
            .map((test: ISchueler_testsAPI) => {
                const schueler = this.schuelerliste.filter(s => s.schueler_id === test.schueler_id)[0] ?? null;
                if (schueler === null)
                    return ``;

                return `<a href="/ergebnisdateneingabe.php?fach=${test.fach}&gruppeid=${test.testgruppe_id}" class="sprungmarke-schueler" data-nr="${schueler.nr}">${schueler.nr.toString().padStart(3, '0')}</a>`;
            })
            .filter(html => html !== '');

        if (schuelerLinks.length === 0)
            return '';

        return `
<div class="status warnung">
    <div>
        <svg role='graphics-symbol'>
            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#exclamation-circle'/>
        </svg>
    </div>
    <div>
        <h2>Ergebnisdateneingabe im Fach ${fachLang} nicht abgeschlossen</h2>
        <p>Die Ergebnisse der folgenden Schüler im Fach ${fachLang} wurden bisher noch nicht vollständig eingegeben.</p>
        <h3>Betroffene Schüler:</h3>
        <div class="betroffene">
            ${schuelerLinks.join('')}
        </div>
    </div>
</div>`;
    }

    private eindeutigeCbtTestgruppen(fach: TFach, tests: readonly ISchueler_testsAPI[]): IGruppe[] {
        const gruppen: IGruppe[] = [];
        tests.forEach((test: ISchueler_testsAPI) => {
            if (test.testgruppe_id === null || test.testgruppe_id === undefined)
                return;
            if (gruppen.some(g => g.gruppe_id === test.testgruppe_id))
                return;

            const gruppe = this.gruppenliste.filter(g => g.gruppe_id === test.testgruppe_id)[0] ?? null;
            if (gruppe === null || !this.isCbtTest(fach, test))
                return;

            gruppen.push(gruppe);
        });

        return gruppen;
    }

    private isCbtTest(fach: TFach, test: ISchueler_testsAPI): boolean {
        const gruppe = this.gruppenliste.filter(g => g.gruppe_id === test.testgruppe_id)[0] ?? null;
        return test.has_cbt_angemeldet === 1 || (gruppe !== null && this.isCbtGruppe(fach, gruppe));
    }

    private isCbtGruppe(fach: TFach, gruppe: IGruppe): boolean {
        if (fach === 'ma')
            return gruppe.is_cbt_mathematik === 1;
        if (fach === 'de')
            return gruppe.is_cbt_deutsch === 1;
        if (fach === 'en')
            return gruppe.is_cbt_englisch === 1;
        return gruppe.is_cbt_franzoesisch === 1;
    }

    private lehrkraftZugangscode(fach: TFach, gruppe: IGruppe): string | null {
        if (fach === 'ma')
            return gruppe.cbt_zugangscode_lehrkraft_mathematik ?? null;
        if (fach === 'de')
            return gruppe.cbt_zugangscode_lehrkraft_deutsch ?? null;
        if (fach === 'en')
            return gruppe.cbt_zugangscode_lehrkraft_englisch ?? null;
        return gruppe.cbt_zugangscode_lehrkraft_franzoesisch ?? null;
    }

    private cbtDomain(): string | null {
        if (this.sessionvariablen.projekt.weiche === 'vera8')
            return 'vera8-cbt.de';
        if (this.sessionvariablen.projekt.weiche === 'vera3')
            return 'vera3-cbt.de';
        if (this.sessionvariablen.projekt.weiche === 'vera5')
            return 'lernstand5-cbt.de';

        return null;
    }

    override async onSeiteFinished(): Promise<boolean> {
        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        return true;
    }
}
